import type { SupplierSearchResult } from 'features/directSuppliers/types/inviteSupplier';
import { SupplierConnectionStates } from 'features/directSuppliers/types/inviteSupplier';

/**
 * Stable mock search results covering all collision states for Invite supplier (dl-61766).
 * `avatarColor` is deliberately mixed: live BE still returns NULL, so rows without it
 * exercise the Avatar initials-hash fallback the UI has to work with today (dl-62526).
 */
export const supplierInviteSearchMockData: SupplierSearchResult[] = [
  {
    id: '101',
    companyName: 'Softwear Apparel',
    connectionState: SupplierConnectionStates.Available,
    selectable: true,
    email: 'admin@softwear.example',
    avatarColor: '#4A538D',
    inviteCode: 'SW-101',
  },
  {
    id: '102',
    companyName: 'Nordic Textiles',
    connectionState: SupplierConnectionStates.AlreadyConnected,
    selectable: false,
    email: 'contact@nordic.example',
    avatarColor: null,
  },
  {
    id: '103',
    companyName: 'Inactive Mills Co',
    connectionState: SupplierConnectionStates.ConnectedInactive,
    selectable: false,
    avatarColor: null,
  },
  {
    id: '104',
    companyName: 'Pending Partners Ltd',
    connectionState: SupplierConnectionStates.RequestPending,
    selectable: false,
    pendingConnectionId: '2',
    email: 'ops@pending.example',
    avatarColor: null,
  },
  {
    id: '105',
    companyName: 'Merge Factory Group',
    connectionState: SupplierConnectionStates.MergeInProgress,
    selectable: false,
    avatarColor: null,
  },
  {
    id: '106',
    companyName: 'Classic Platform Suppliers',
    connectionState: SupplierConnectionStates.OnClassicPlatform,
    selectable: false,
    avatarColor: null,
  },
  {
    id: '107',
    companyName: 'Available Fabrics Inc',
    connectionState: SupplierConnectionStates.Available,
    selectable: true,
    email: 'hello@fabrics.example',
    avatarColor: '#CF706C',
    inviteCode: 'AF-107',
  },
];

/**
 * Extra selectable rows sharing the `scrollfiller` search term (dl-63919/DL-63933) — the base
 * 7-row set above doesn't reliably overflow the dropdown's 300px listbox, so this gives that one
 * story a guaranteed >7-match, scrollable result set without touching the other stories' `'e'`
 * search assumptions (SEARCH_TERM_ALL_STATES).
 */
export const supplierInviteSearchScrollFillerMockData: SupplierSearchResult[] = Array.from(
  { length: 9 },
  (_, index) => ({
    id: `2${index}`,
    companyName: `Scrollfiller Supplier ${index + 1}`,
    connectionState: SupplierConnectionStates.Available,
    selectable: true,
    email: `scrollfiller${index + 1}@example.com`,
    avatarColor: null,
  })
);
